import moment from 'moment'
import { useContext, useState } from 'react'
import { Column } from 'react-table'
import { IOrder } from '../../../../../../app/entities/Order'
import TableTitle from '../../../../global/components/table/helpers/table-title/TableTitle'
import TableTopper from '../../../../global/components/table/helpers/table-topper/TableTopper'
import Table from '../../../../global/components/table/Table'
import { AuditContext } from '../../../../global/context/audit-context/AuditContext'
import { getAllTireRackOrderNumbers } from '../../../../global/utils/tire-rack-orders'

function AuditOverviewSummaryTable() {
  const { order } = useContext(AuditContext)
  const [isOpen, setIsOpen] = useState(true)
  const tableState = {
    data: order ? [order] : [],
    isLoading: false,
  }

  const columns: Column<IOrder | any>[] = [
    {
      Header: 'Order ID',
      accessor: 'workOrderId',
    },
    {
      Header: 'TR Order Number(s)',
      Cell: ({ row: { original } }) => {
        const allTireRackOrderNumbers = getAllTireRackOrderNumbers(
          original as IOrder,
        )
        return (
          <div>
            {allTireRackOrderNumbers.length > 0
              ? allTireRackOrderNumbers.join(', ')
              : 'N/A'}
          </div>
        )
      },
    },
    {
      Header: 'Status',
      Cell: ({ row: { original } }) => {
        const { status } = original as IOrder
        return <div>{status}</div>
      },
    },
    {
      Header: 'Service Appt',
      Cell: ({ row: { original } }) => {
        const { timeSlot, routeInstructions } = original as any

        if (routeInstructions.length)
          return <div>{routeInstructions[0].startTimeGenerated}</div>

        if (timeSlot) return <div>{timeSlot.fromTimeGenerated}</div>

        return <div>Appointment information not available.</div>
      },
    },
    {
      Header: 'Prelim Appt',
      accessor: 'timeSlot.fromDateGenerated',
      Cell: ({ row: { original } }) => {
        const { timeSlot, routeInstructions } = original as IOrder

        if (routeInstructions.length)
          return (
            <div>
              {moment.utc(routeInstructions[0].startTime).format('MM/DD/YY')}
            </div>
          )

        if (timeSlot) return <div>{timeSlot.fromDateGenerated}</div>

        return <div>-</div>
      },
    },
    {
      Header: 'Time Slot',
      accessor: 'timeSlot.type',
    },
    {
      Header: 'Location',
      accessor: 'location.name',
    },
    {
      Header: 'Van',
      accessor: 'van.name',
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <TableTopper
        isOpen={isOpen}
        onToggleClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <TableTitle>Overview / Summary Info</TableTitle>
        </div>
      </TableTopper>
      <Table
        columns={columns}
        data={tableState.data}
        isDisplayMode={true}
        isOpen={isOpen}
      />
    </div>
  )
}

export default AuditOverviewSummaryTable
